<!-- 综合屏 -->
<template>
  <div class="audit" id="indexMain">
    <div id="container"></div>

    <div class="top-center">
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-user"></i>
          服务企业
        </div>
        <div class="top-center-value">
          <count-to
            style="font-family: 'DIGGI'"
            :start-val="0"
            :end-val="companyCount"
            :duration="2000"
          ></count-to>
          <span class="value-unit">家</span>
        </div>
      </div>
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-menu"></i>
          危废种类
        </div>
        <div class="top-center-value">
          <count-to
            style="font-family: 'DIGGI'"
            :start-val="0"
            :end-val="categoryCount"
            :duration="2000"
          ></count-to>
          <span class="value-unit">种</span>
        </div>
      </div>
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-s-data"></i>
          危废重量
        </div>
        <div class="top-center-value">
          <count-to
            style="font-family: 'DIGGI'"
            :start-val="0"
            :end-val="dangerWasterWeight"
            :duration="2000"
          ></count-to>
          <span class="value-unit">吨</span>
        </div>
      </div>

      <div class="search-input">
        <el-input
          clearable
          style="width: 100%"
          suffix-icon="el-icon-search"
          v-model="companyName"
          @change="getMapData()"
        >
        </el-input>
      </div>
    </div>

    <div class="title-left-dropdown">
      <div class="weather-info">
        {{ weather.temperature }} ℃ {{ weather.weather }}
        {{ weather.province + " - " + weather.city }}
      </div>
    </div>
    <div
      class="titles"
      style="font-size: 24px; font-weight: bold; color: #ffffff"
    >
      <span style="letter-spacing: 4.22px"
        >大兴生物医药产业基地智慧化危险废物管理平台</span
      >
      <div class="title-date">{{ dateYear }} {{ dateDay }} {{ dateWeek }}</div>
      <div class="title-dropdown">
        <span
          style="
            width: 75px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
            color: #fff;
            font-size: 14px;
          "
          >{{ userName }}</span
        >
      </div>
    </div>
    <!-- 以上是头部布局 -->
    <div class="lefts">
      <div class="left-days">
        <div class="days-title">
          <span
            style="cursor: pointer"
            @click="$router.push('zfStatistics/zonglan')"
            >业务统计</span
          >
        </div>
        <div class="days-content">
          <div class="tags">
            <div>
              <el-radio-group
                style="display: flex; flex-wrap: nowrap; padding-right: 10px"
                @input="changeDateType"
                v-model="dateType"
                fill="#18b0f9"
                size="mini"
              >
                <el-radio-button label="year">年</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
              </el-radio-group>
            </div>
            <div>
              <el-date-picker
                v-if="dateType == 'month'"
                :clearable="false"
                prefix-icon=""
                v-model="dateRange"
                type="monthrange"
                range-separator="-"
                value-format="yyyy-MM"
                size="mini"
                :picker-options="pickerOptions"
                style="width: 200px"
                @change="getStatistics()"
              >
              </el-date-picker>
              <div v-else style="display: flex">
                <el-date-picker
                  style="width: 100px; padding-right: 5px"
                  :clearable="false"
                  size="mini"
                  v-model="searchParams.startYear"
                  :picker-options="startDatePicker"
                  value-format="yyyy"
                  type="year"
                  @change="getStatistics()"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: 100px; padding-left: 5px"
                  :clearable="false"
                  size="mini"
                  v-model="searchParams.endYear"
                  :picker-options="endDatePicker"
                  value-format="yyyy"
                  type="year"
                  @change="getStatistics()"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div id="businese-content"></div>
        </div>
      </div>
      <div class="left-days">
        <div class="days-title">
          <span
            style="cursor: pointer"
            @click="$router.push('zfWarning/charts')"
            >预警/警报</span
          >
        </div>
        <div class="days-content">
          <div class="tags">
            <el-radio-group
              @input="changeLastDay"
              v-model="lastDay"
              fill="#18b0f9"
              size="mini"
            >
              <el-radio-button label="0">今日</el-radio-button>
              <el-radio-button label="30">近30日</el-radio-button>
              <el-radio-button label="90">近90日</el-radio-button>
            </el-radio-group>
          </div>
          <div class="warning-table">
            <vue-seamless-scroll
              :data="warningsData"
              class="seamless-warp"
              :class-option="optionSetting"
            >
              <div
                v-for="item in warningsData"
                :key="item.id"
                class="warning-box"
              >
                <div class="warning-box-img">
                  <img
                    v-if="item.status == '已消除'"
                    src="./assets/已消除.svg"
                  />
                  <img v-else src="./assets/警报.svg" />
                  <div
                    :style="{
                      color: item.status == '已消除' ? '#ccc' : '#FF5D5D',
                    }"
                  >
                    {{ item.status }}
                  </div>
                </div>
                <div class="warning-box-content">
                  <div class="warning-companyname">
                    {{ item.companyName }}
                  </div>
                  <div class="warning-text">
                    {{ filterWarningContext(item.warningContent) }}
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
            <!-- <vue-seamless-scroll
              :data="warningsData"
              class="seamless-warp"
              :class-option="optionSetting"
            >
              <div v-for="o in 4" :key="o" class="warning-box">
                <img src="./assets/警报.svg" /> {{ "列表内容 " + o }}
              </div>
            </vue-seamless-scroll> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="centers">
      <p class="centers-title">生态环境</p>
    </div> -->
    <div class="rights">
      <div class="left-days">
        <div class="days-title">
          <span style="cursor: pointer" @click="$router.push('exam/index')"
            >考核整改</span
          >
        </div>
        <div class="days-content">
          <ul class="list-title">
            <li>
              <p class="examResult-table-no" title="序号">序号</p>
              <p class="examResult-table-name" title="企业名称">企业名称</p>
              <p class="examResult-table-date" title="日期">日期</p>
              <p class="examResult-table-score" title="分数">分数</p>
            </li>
          </ul>
          <vue-seamless-scroll
            :data="examResultData"
            class="seamless-warp"
            :class-option="optionSetting"
          >
            <ul class="scoll-main">
              <li
                class="main-list"
                v-for="(item, index) in examResultData"
                :key="index"
              >
                <p class="examResult-table-no" :title="item.index">
                  {{ index + 1 }}
                </p>
                <p class="examResult-table-name" :title="item.companyName">
                  {{ item.companyName }}
                </p>
                <p class="examResult-table-date" :title="item.date">
                  {{ $dayjs(item.date).format("YYYY-MM-DD") }}
                </p>
                <p class="examResult-table-score" :title="item.score">
                  {{ item.score }}
                </p>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
      <div class="left-days">
        <div class="days-title">
          <span style="cursor: pointer" @click="$router.push('exam/index')"
            >实时监控</span
          >
        </div>
        <div class="days-content">
          <img
            src="./assets/jk.jpg"
            style="margin-top: 30px; width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <div class="category-menu-index">
      <div v-for="item in categoryMenu" :key="'category-' + item.text">
        <img :src="item.icon" />
        {{ item.text }}
      </div>
    </div>

    <div class="right-goin" @click="$router.push('zfMap/category')">
      <!-- <img src="./../../assets/newImages/jinru.png" alt="" srcset="" /> -->
    </div>

    <!-- <div class="search-input">
      <el-input
        clearable
        style="width: 100%"
        suffix-icon="el-icon-search"
        v-model="companyName"
        @change="getMapData()"
      >
      </el-input>
    </div> -->
    <companyDetail style="color: #000" ref="companyDetail"></companyDetail>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import screenfull from "screenfull";
import vueSeamlessScroll from "vue-seamless-scroll";
import * as echarts from "echarts";
import zhongdianIcon from "@/assets/markers/zhongdian.svg";
import dengjiIcon from "@/assets/markers/dengji.svg";
import jianhuaIcon from "@/assets/markers/jianhua.svg";
import chuzhiIcon from "@/assets/markers/chuzhi.svg";
import countTo from "vue-count-to";
import companyDetail from "@/components/companyDetail.vue";

export default {
  name: "",
  //import引入的组件需要注入到对象中才能使用
  components: {
    countTo,
    vueSeamlessScroll,
    companyDetail,
  },
  data() {
    //这里存放数据
    return {
      companyCount: 0,
      categoryCount: 0,
      dangerWasterWeight: 0,
      examResultData: [],
      weather: {},
      dateRange: [],
      searchParams: {
        startYear: null,
        endYear: null,
      },
      pickerMinDate: null,
      pickerMaxDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 30 * 24 * 3600 * 1000 * 6;
            let maxTime = this.pickerMinDate + day1;
            let minTime = this.pickerMinDate - day1;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      startDatePicker: {
        disabledDate: (time) => {
          const thisYear = new Date().getFullYear();
          if (this.searchParams.endYear) {
            return (
              time.getFullYear() >= this.searchParams.endYear ||
              time.getFullYear() < this.searchParams.endYear - 6 ||
              time.getFullYear() > thisYear
            );
          } else {
            return time.getFullYear() > thisYear;
          }
        },
      },
      endDatePicker: {
        disabledDate: (time) => {
          const thisYear = new Date().getFullYear();
          if (this.searchParams.startYear) {
            return (
              time.getFullYear() <= this.searchParams.startYear ||
              time.getFullYear() > parseInt(this.searchParams.startYear) + 6 ||
              time.getFullYear() > thisYear
            );
          } else {
            return time.getFullYear() > thisYear;
          }
        },
      },
      dateType: "year",
      lastDay: "90",
      warningsData: [],
      statisticsData: [],
      isShowInfo: false,
      companyInfo: {},
      categoryMenu: [
        {
          text: "重点监管",
          icon: zhongdianIcon,
        },
        {
          text: "登记管理",
          icon: dengjiIcon,
        },
        {
          text: "简化管理",
          icon: jianhuaIcon,
        },
        {
          text: "处置企业",
          icon: chuzhiIcon,
        },
      ],
      companyName: "",
      companies: [],
      markers: [],
      map: null,
      userName: "",
      userToken: "",
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timer: null,
      stsData: {},
      date: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 设置底部滚动
    optionSetting() {
      return {
        step: 0.1, // 数值越大速度滚动越快
        // limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 30, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 50, // 单步运动停止的时间(默认值1000ms)
      };
    },

    dateSearch() {
      if (this.dateType == "year") {
        return {
          startDate: this.searchParams.startYear + "-01",
          endDate: this.searchParams.endYear + "-01",
        };
      } else {
        return { startDate: this.dateRange[0], endDate: this.dateRange[1] };
      }
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getCount() {
      const url = this.$api.cockpit.getCount;
      this.$axios.get(url, null, false).then((res) => {
        if (res.data.code == 0) {
          const { companyCount, categoryCount, dangerWasterWeight } =
            res.data.data;
          this.companyCount = companyCount;
          this.categoryCount = categoryCount;
          this.dangerWasterWeight = dangerWasterWeight;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    filterWarningContext(text) {
      const index = text.indexOf("，请修改危废管理计划");

      return index > 0 ? text.substring(0, index) : text;
    },
    getWeather() {
      const url = this.$api.cockpit.getWeather;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.weather = res.data.data.lives[0];
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    goToList() {
      this.$router.push("/zfMap/category");
    },
    //#region 地图相关
    initMap() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        animateEnable: false,
        // mapStyle: 'amap://styles/light',
        mapStyle: "amap://styles/darkblue",
        // // showLabel: false,
        // features: ['bg', 'road', 'building'],
        center: [116.29920714, 39.681], //初始地图的中心点坐标
        zoom: 15,
      });
      this.getMapData();
    },
    getMapData() {
      let url = this.$api.cockpit.getMap;
      const params = {
        name: this.companyName,
      };
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          this.companies = res.data.data.companies;
          // this.map.clearMap()
          this.map.remove(this.markers);
          this.addMarker();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    //2.添加点标记
    addMarker() {
      const self = this;
      let arr = [];
      this.isShowInfo = false;
      this.map.remove(this.markers);
      this.markers = [];
      this.companies.forEach((item) => {
        let iconImg = null;
        switch (item.manageCategory) {
          case "重点监管":
            iconImg = zhongdianIcon;
            break;
          case "简化管理":
            iconImg = jianhuaIcon;
            break;
          case "登记管理":
            iconImg = dengjiIcon;
            break;
          case "处置单位":
            iconImg = chuzhiIcon;
            break;
        }
        const icon = new AMap.Icon({
          image: iconImg, //require('@/assets/markers/zhongdian.svg'), // Icon的图像
          // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 35), // 根据所设置的大小拉伸或压缩图片
        });

        const position = [item.lng, item.lat];

        let marker = new AMap.Marker({
          icon, //点标记图片路径
          position, //位置
          anchor: "bottom-center",
        });
        arr.push(
          Object.assign(item, {
            mapId: marker._amap_id,
          })
        );
        marker.setMap(self.map);
        marker.on("click", (e) => {
          let infoWindow = this.createInfoWindow(item);
          infoWindow.open(this.map, marker.getPosition());
        });
        // marker.on("mouseout", (e) => {
        //   this.map.clearInfoWindow();
        // });
        this.markers.push(marker);
      });
    },
    //创建弹窗
    createInfoWindow(data) {
      const eventx = require("@/assets/newImages/eventx.png");
      let sContent = `<div 
      class="content-window-card"
    > 
        <img 
          src="${eventx}" style="height: 20px;
           width: 45px;
           cursor: pointer;
           position: absolute;
           right: -2px;
           z-index:99;
           top: 8px;"
          
           onclick="closeInfoWindow()"
        />
      </div>
      <div class="info-middle">
        <div  style="margin: 12px 0px;position: relative;">
          <div class="popup-row"> 
        <div class="popup-row-label"> 企业名称：</div>
        <div class="popup-row-value">  ${data.name}</div> 
      </div>
      <div class="popup-row"> 
        <div class="popup-row-label"> 管理类型：</div>
        <div class="popup-row-value">  ${data.manageCategory}</div> 
      </div>
      <div class="popup-row"> 
        <div class="popup-row-label"> 地址：</div>
        <div class="popup-row-value">  ${data.addr}</div> 
      </div>
      <div class="popup-row"> 
        <div class="popup-row-label"> 危废产生量：</div>
        <div class="popup-row-value">  ${data.dangerWaster} 吨</div> 
      </div>
      <div class="company-detail">
          <span style="
            position: absolute;
            right: 10px;
            color: #fff;
            font-weight: bolder;
            cursor: pointer;"
            onclick="showDetail()">查看详情 >>></span>
        </div>
        </div>
      </div>
      <div 
        style="margin: 0 auto;
              width: 40px;
              height: 20px;
              bottom:-18px;
              position: relative;
              overflow: hidden;">
              <div class="tdt-infowindow-tip"></div>
      </div>
    </div>`;
      let infoWindowData = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: sContent,
        // content: this.getContent(),
        anchor: "bottom-center",
        offset: new AMap.Pixel(0, -40),
      });
      window.showDetail = () => {
        this.showDetail(data);
      };
      window.closeInfoWindow = () => {
        console.log("close");
        this.map.clearInfoWindow();
      };
      return infoWindowData;
    },
    //#endregion

    //#region 业务统计
    changeDateType() {
      this.getStatistics();
    },

    //获取统计
    getStatistics() {
      const url = this.$api.cockpit.getStatistics;
      let params = {
        ...this.dateSearch,
        dateType: this.dateType,
      };
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          this.statisticsData = res.data.data;
          this.drawDwdChart();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    drawDwdChart() {
      const data = this.statisticsData;

      const resData = data.reduce(
        (prev, current) => {
          Object.keys(current).forEach((key) => {
            prev[key].push(current[key]);
          });
          return prev;
        },
        {
          date: [],
          产生量: [],
          贮存量: [],
          处置量: [],
        }
      );

      let option = {
        // title: {
        //   text: '危废数据'
        // },
        grid: {
          left: "0",
          botttom: "0",
          containLabel: true,
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {
          data: ["产生量", "处置量", "贮存量"],
          textStyle: { fontSize: 14, color: "#fff" },
          itemWidth: 25,
          itemHeight: 15,
          itemGap: 15,
          top: "5%",
          selectedMode: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter: (params) => {
            let rander = params
              .map((item) =>
                item.seriesType !== "pictorialBar"
                  ? `<div>${item.marker} ${item.seriesName}: ${
                      item.value + "吨"
                    }</div>`
                  : ""
              )
              .join("");
            return `
            <div>${params[0].axisValue}</div>
            ${rander}
        `;
          },
        },

        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,
            // rotate: 40,
            textStyle: {
              color: "#fff", // 修改x轴标签颜色
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          data: resData.date,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },

          axisLabel: {
            textStyle: {
              color: "#fff", // 修改y轴标签颜色
            },
            formatter: "{value} 吨",
          },
        },
        series: [
          {
            z: 1,
            name: "上部1",
            type: "pictorialBar",
            symbolPosition: "end",
            data: resData["产生量"],
            symbol: "diamond",
            symbolOffset: ["-50%", "-50%"],
            symbolSize: [29, 19],
            itemStyle: {
              borderColor: "#2fffa4",
              color: "#2fffa4",
            },
          },
          {
            z: 1,
            type: "bar",
            name: "产生量",
            barWidth: 30,
            barGap: "-50%",
            data: resData["产生量"],
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                x2: 1,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgba(29, 245, 160, .7)" },
                  { offset: 0.5, color: "rgba(29, 245, 160, .7)" },
                  { offset: 0.5, color: "rgba(29, 245, 160, .3)" },
                  { offset: 1, color: "rgba(29, 245, 160, .3)" },
                ],
              },
            },
          },
          {
            z: 2,
            name: "上部1",
            type: "pictorialBar",
            symbolPosition: "end",
            data: resData["处置量"],
            symbol: "diamond",
            symbolOffset: [0, "-50%"],
            symbolSize: [29, 19],
            itemStyle: {
              borderColor: "#32ffee",
              color: "#32ffee",
            },
          },
          {
            z: 2,
            type: "bar",
            name: "处置量",
            barWidth: 30,
            data: resData["处置量"],
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                x2: 1,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgba(50, 255, 238, .7)" },
                  { offset: 0.5, color: "rgba(50, 255, 238, .7)" },
                  { offset: 0.5, color: "rgba(50, 255, 238, .3)" },
                  { offset: 1, color: "rgba(50, 255, 238, .3)" },
                ],
              },
            },
          },
          {
            z: 3,
            name: "上部1",
            type: "pictorialBar",
            symbolPosition: "end",
            data: resData["贮存量"],
            symbol: "diamond",
            symbolOffset: ["50%", "-50%"],
            symbolSize: [29, 19],
            itemStyle: {
              borderColor: "#ffd11a",
              color: "#ffd11a",
            },
          },
          {
            z: 3,
            type: "bar",
            name: "贮存量",
            barWidth: 30,
            data: resData["贮存量"],
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                x2: 1,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgba(255, 209, 26, .7)" },
                  { offset: 0.5, color: "rgba(255, 209, 26, .7)" },
                  { offset: 0.5, color: "rgba(255, 209, 26, .3)" },
                  { offset: 1, color: "rgba(255, 209, 26, .3)" },
                ],
              },
            },
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("businese-content"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    //#endregion

    //预警
    changeLastDay() {
      this.getWarnings();
    },
    getWarnings() {
      const url = this.$api.cockpit.getWarnings;
      let params = {
        lastDay: this.lastDay,
      };
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          this.warningsData = res.data.data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getExamResult() {
      const url = this.$api.cockpit.getExamResult;
      let params = {};
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          this.examResultData = res.data.data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    showDetail(data) {
      this.$refs.companyDetail.getCompanyInfo(data);
    },
    getStsData() {
      const url = this.$api.sts.sts;
      const params = this.searchParams;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          const { data } = res.data;
          this.stsData = data;
          this.drawDayBarChart();
          this.drawHasWaterPieChart();
          this.drawClothPieChart();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    appAuthsFun() {
      let { name } = JSON.parse(window.sessionStorage.getItem("tokenData"));
      this.userName = name;
    },
    checkOut() {
      // let data;
      // // 切换页码如果有记录数据点击时根据记录数据分页，如果没有则按照返回数据分页
      // data = {
      //   token: this.userToken,
      // };
      // let url = this.$api.alilogout;
      // this.$axios
      //   .post(url, this.$qs.stringify(data), false)
      //   .then((res) => {
      //     if (res.data.code == 0) {
      //       window.opener = null;
      //       window.open("", "_self");
      //       window.close();
      //       sessionStorage.removeItem("permission");
      //       sessionStorage.removeItem("getMenuList");
      //       sessionStorage.removeItem("tokenData");
      //       sessionStorage.removeItem("appAuths");
      //       sessionStorage.removeItem("userName");
      //       sessionStorage.removeItem("userToken");
      //       window.location.href = "http://192.162.20.26:28088/web/";
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    // goHomeIndex() {
    //   window.location.href = "http://192.162.20.26:28088/web/home";
    // },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // const today = this.$dayjs().format("YYYY-MM-DD");
    // // const yesterday = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
    // this.date.push(today, today);
    // this.searchParams.begin = today;
    // this.searchParams.end = today;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getWeather();
    this.appAuthsFun();
    this.initMap();
    // this.getStsData();
    this.getCount();

    const thisYear = new Date().getFullYear();

    this.searchParams.startYear = thisYear - 1 + "";
    this.searchParams.endYear = thisYear + "";
    const m1 = this.$dayjs().subtract(6, "month").format("YYYY-MM");
    const m2 = this.$dayjs().format("YYYY-MM");
    this.dateRange = [m1, m2];
    this.getStatistics();
    this.getWarnings();

    this.getExamResult();

    this.timer = setInterval(() => {
      const date = this.$dayjs(new Date());
      this.dateDay = date.format("HH:mm:ss");
      this.dateYear = date.format("YYYY-MM-DD");
      this.dateWeek = date.format(this.weekday[date.day()]);
    }, 1000);

    // this.loadmap();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss">
@import url("./assets/index.css");

/* @import url(); 引入公共css类 */
.audit {
  * {
    font-family: FZZ;
  }

  // .el-radio-button__inner {
  //   border-radius: 4px 4px 4px 4px !important;
  //   // width: 88px !important;
  //   background: #024287;
  //   color: #7cc8ff;
  //   font-size: 14px;
  //   border: none !important;
  //   padding: 7px 6px;
  // }

  // .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  //   background: #18b0f9;
  //   font-size: 14px;
  //   border: none !important;
  //   color: #ffffff;
  // }

  // .el-radio-button {
  //   margin-right: 10px !important;
  // }

  // .is-checked {
  //   background: rgba(8, 174, 240, 0.6);
  //   /* 透明 */
  //   border: none;
  //   color: white;
  // }
}

.hidden {
  display: none;
}

.main-title {
  font-size: 16px;
  color: #47f0fb;
  font-weight: 700;
  text-align: center;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-top: 15px;
}
.tags {
  width: 100%;
  display: flex;
  margin-top: 10px;
}

.route-corridor {
  width: 200px;
  // stroke: red;
  // stroke-opacity: 0.4;
}

.look-history {
  text-align: right;
}

.list-title {
  cursor: default;
}
.videoBox-left {
  margin-right: 25px;
  width: 230px;
}
</style>

<style lang="scss" scoped>
#businese-content {
  width: 100%;
  height: 100%;
}

.main-list {
  cursor: pointer;
}
.category-menu-index {
  position: absolute;
  bottom: 100px;
  right: 400px;
  cursor: pointer;
  color: #fff;
  border-radius: 3px;
  width: 130px;
  height: 180px;
  display: flex;
  flex-direction: column;
  background: #000001;
  > div {
    padding: 12px 20px;
  }
}

.top-center-inner {
  .top-center-title {
    color: #fff;
  }

  .top-center-value {
    color: rgb(71, 247, 253);
    font-weight: bold;
    font-size: 38px;
    width: 150px;
    height: 50px;
    line-height: 50px;
    padding-left: 16px;
    background: linear-gradient(to right, #20417f, #111944);
    border-radius: 5px;
    font-family: "DIGGI";
    .value-unit {
      font-size: 12px;
      color: #fff;
    }
  }
}

.top-center {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 100px;
  width: calc(100% - 770px);
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  height: 20px;
}

.weather-info {
  color: #fff;
}
.warning-table {
  margin-top: 5px;
  height: 116%;
}
.warning-box {
  width: calc(100% - 10px);
  height: auto;
  margin-bottom: 10px;
  // border: 1px solid #fff;
  color: #ffffff;
  display: flex;
  align-items: center;
  background-color: rgba(216, 19, 19, 0.3);
  border-radius: 10px;
  .warning-box-img {
    width: 150px !important;
    padding: 10px;
    text-align: center;
    img {
      margin-bottom: 10px;
    }
  }
  .warning-box-content {
    padding: 8px 8px 8px 0;
    .warning-companyname {
      color: #47f0fb;
      font-size: 16px;
      font-weight: bold;
    }
    .warning-text {
      color: #d7d7d7;
    }
  }
}
.search-input {
  // position: absolute;
  // top: 190px;
  // right: 400px;
  margin-top: 30px;
  z-index: 99;
  width: 200px;
  border-radius: 4px;
  /deep/.el-input__inner {
    background-color: rgba(0, 0, 1, 0.5) !important;
    border-color: #fff;
    // color: #47f7fd;
    color: #fff;
  }

  /deep/ .el-input__suffix {
    // color: #47f7fd;
    color: #fff;
  }
}

/deep/.popup-row {
  width: 350px;
  // width: 100%;
  padding: 4px 10px;
  font-size: 13px;
  display: flex;
  &::after {
    clear: both;
    content: "";
    display: block;
  }

  .popup-row-label {
    width: 90px;
    // display: inline-block;
    color: #7dc3f6;
    text-align: right;
    font-size: 14px;
  }

  .popup-row-value {
    flex: 1;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // display: block;
    // margin-left: 100px;
    color: #d7d7d7;
    font-size: 14px;
  }
}
/deep/ .amap-info {
  background: url("../../assets/newImages/infoWindow.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  // color: #024287;
}

/deep/ .tdt-container a.tdt-infowindow-close-button {
  color: transparent;
  background: url("../../assets/newImages/eventx.png") no-repeat;
  background-size: 100% 100%;
  width: 40px;
  height: 20px;
}
/deep/ .tdt-infowindow-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #094a92;
}
.el-input__inner {
  background-color: transparent;
}
/deep/ .el-date-editor .el-range-input {
  background-color: transparent;
  color: #fff;
}
/deep/ .el-range-separator {
  color: #fff;
}
/deep/ .el-date-editor .el-range__icon {
  color: #fff;
}
/deep/ .el-date-editor .el-range__close-icon {
  color: #fff;
}
</style>